<template>
  <b-button size="sm" class="rounded-circle card-link go-back" @click="goBack">
    <b-icon-arrow-left />
  </b-button>
</template>

<script>
import {
  BButton,
  BIconArrowLeft,
} from 'bootstrap-vue';

export default {
  components: {
    BButton,
    BIconArrowLeft,
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
  name: 'BackButton',
};
</script>

<style scoped>
.go-back {
  background-color: #addbe5;
  color: darkblue;
  padding: 8px;
}
</style>
